/**
 * Typed readers for the custom data this app stores on Stream — the feeds SDK types `custom` as
 * `Record<string, any>` with no augmentation hook (unlike stream-chat's CustomUserData), so these
 * runtime-guarded accessors are the single place that knows the wire keys. The snake_case activity
 * keys mirror the backend's StoryActivityPayload custom fields; `accessRole` mirrors
 * ChatStreamUserMapper's user profile (shared by chat and stories).
 */

/** Story CTA/sheet fields, named as the Story presentation model expects them. */
export type StoryActivityCustomData = {
  buttonLabel?: string;
  buttonUrl?: string;
  sheetTitle?: string;
  sheetDescription?: string;
  sheetPrice?: string;
  sheetPriceNote?: string;
  sheetImageUrl?: string;
};

const asOptionalString = (value: unknown): string | undefined =>
  typeof value === "string" ? value : undefined;

export const getStoryActivityCustomData = (
  custom: Record<string, unknown>,
): StoryActivityCustomData => ({
  buttonLabel: asOptionalString(custom.button_label),
  buttonUrl: asOptionalString(custom.button_url),
  sheetTitle: asOptionalString(custom.sheet_title),
  sheetDescription: asOptionalString(custom.sheet_description),
  sheetPrice: asOptionalString(custom.sheet_price),
  sheetPriceNote: asOptionalString(custom.sheet_price_note),
  sheetImageUrl: asOptionalString(custom.sheet_image_url),
});

/** The AccessRole code stamped on every Stream user profile the backend upserts. */
export const getStreamUserAccessRole = (
  custom: Record<string, unknown>,
): string | undefined => asOptionalString(custom.accessRole);
